<template>
  <div class="pcm-scroll" ref="scroller" @scroll.passive="onScroll">
    <div class="pcm-navBar" ref="navBar" :style="{ height: navBarHeight }">
      <div class="pcm-navInner" :style="scaleStyle">
        <div class="pcm-logo">
          <img class="pcm-logoImg" :src="logoImg" alt="" />
          <span>黄果短剧</span>
        </div>
        <nav class="pcm-menu">
          <button
            v-for="item in menus"
            :key="item.key"
            type="button"
            class="pcm-menuItem"
            :class="{ 'is-active': activeKey === item.key }"
            @click="scrollToSection(item.key)"
          >
            <span class="pcm-menuLabel">
              <span class="pcm-menuGhost">{{ item.label }}</span>
              <span class="pcm-menuText">{{ item.label }}</span>
            </span>
            <i class="pcm-menuLine"></i>
          </button>
        </nav>
        <button
          type="button"
          class="pcm-client"
          @click="openQr('手机扫码下载')"
        >
          <span class="pcm-clientIcon">
            <img :src="downloadIcon" alt="" />
          </span>
          <span>客户端</span>
        </button>
      </div>
    </div>

    <div class="pcm-stage" :style="{ height: stageHeight + 'px' }">
      <div class="pcm-page" ref="page" :style="scaleStyle">
        <section class="pcm-hero" ref="home">
          <img class="pcm-fill" :src="heroImg" alt="" />
          <button
            type="button"
            class="pcm-btn pcm-btnDownload"
            @click="openQr('手机扫码下载')"
          >
            <span class="pcm-btnIcon">
              <img class="pcm-iconLg" :src="downloadLgIcon" alt="" />
            </span>
            <span>下载黄果短剧</span>
          </button>
          <button
            type="button"
            class="pcm-btn pcm-btnExplore"
            @click="scrollToSection('genres')"
          >
            <span class="pcm-btnIcon pcm-btnIconBrand">
              <img class="pcm-iconPlay" :src="playIcon" alt="" />
            </span>
            <span>探索精彩内容</span>
          </button>
        </section>

        <section class="pcm-highlights" ref="highlights">
          <img class="pcm-fill" :src="highlightsImg" alt="" loading="lazy" decoding="async" />
        </section>

        <section class="pcm-genres" ref="genres">
          <img class="pcm-fill" :src="genresImg" alt="" loading="lazy" decoding="async" />
        </section>

        <section class="pcm-immersive">
          <img class="pcm-fill" :src="immersiveImg" alt="" loading="lazy" decoding="async" />
        </section>

        <section class="pcm-wish" ref="wish">
          <img class="pcm-fill" :src="wishImg" alt="" loading="lazy" decoding="async" />
          <button
            type="button"
            class="pcm-btn pcm-btnWish"
            @click="openQr('扫码打开 App 许愿')"
          >
            <span class="pcm-btnIcon pcm-btnIconSm">
              <img class="pcm-iconEdit" :src="editIcon" alt="" />
            </span>
            <span>去许愿</span>
          </button>
        </section>

        <section class="pcm-creator" ref="original">
          <img class="pcm-fill" :src="creatorImg" alt="" loading="lazy" decoding="async" />
        </section>

        <section class="pcm-about" ref="about">
          <div class="pcm-aboutInner">
            <div class="pcm-aboutLogo">
              <img :src="logoImg" alt="" />
              <span>黄果短剧</span>
            </div>
            <div class="pcm-aboutCopy">
              <p>打开黄果短剧，</p>
              <p>遇见更多精彩故事</p>
            </div>
          </div>
        </section>

        <footer class="pcm-footer">
          <div class="pcm-brand">
            <div class="pcm-footerLogo">
              <img :src="logoImg" alt="" />
              <span>黄果短剧</span>
            </div>
            <p class="pcm-brandSlogan">随时随地，打开好戏世界</p>
            <div class="pcm-addresses">
              <p>
                <span>黄果短剧国内地址：</span>
                <a
                  href="https://hgdhy1.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://hgdhy1.com</a
                >
              </p>
              <p>
                <span>黄果短剧最新地址：</span>
                <a
                  href="https://d1moq9tellvyj5.cloudfront.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://d1moq9tellvyj5.cloudfront.net</a
                >
              </p>
              <p>
                <span>黄果短剧官网地址：</span>
                <a
                  href="https://huangguo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://huangguo.com</a
                >
              </p>
              <p>
                <span>黄果短剧永久发布页：</span>
                <a
                  href="https://hgdj.fm"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://hgdj.fm</a
                >
              </p>
            </div>
          </div>
          <div class="pcm-footCol pcm-footSupport">
            <p class="pcm-footTitle">服务支持</p>
            <p>常见问题</p>
            <p>用户反馈</p>
          </div>
          <div class="pcm-footCol pcm-footAbout">
            <p class="pcm-footTitle">关于我们</p>
            <p>公司简介</p>
            <p>联系我们</p>
          </div>
          <div class="pcm-footCol pcm-footLegal">
            <p class="pcm-footTitle">法律信息</p>
            <p>用户协议</p>
            <p>隐私政策</p>
          </div>
          <p class="pcm-copyright">
            Copyright © 2026 黄果短剧. All Rights Reserved.
          </p>
        </footer>
      </div>
    </div>

    <transition name="pcm-fade">
      <div v-if="qrVisible" class="pcm-qrMask" @click="closeQr">
        <div class="pcm-qrCard" @click.stop>
          <div class="pcm-qrTitle">{{ qrTitle }}</div>
          <div class="pcm-qrBox">
            <img v-if="qrImg" class="pcm-qrImg" :src="qrImg" alt="" />
            <span v-else>二维码生成中</span>
          </div>
          <div class="pcm-qrSub">支持 iOS 与 Android</div>
          <button type="button" class="pcm-qrConfirm" @click="closeQr">
            我知道了
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import logoImg from "@/assets/images/land/logo.webp";
import heroImg from "@/assets/images/land/hero.webp";
import highlightsImg from "@/assets/images/land/highlights.webp";
import genresImg from "@/assets/images/land/genres.webp";
import immersiveImg from "@/assets/images/land/immersive.webp";
import wishImg from "@/assets/images/land/wish.webp";
import creatorImg from "@/assets/images/land/creator.webp";
import downloadIcon from "@/assets/images/land/download.svg";
import downloadLgIcon from "@/assets/images/land/download-lg.svg";
import playIcon from "@/assets/images/land/play.svg";
import editIcon from "@/assets/images/land/edit.svg";

const PAGE_WIDTH = 1440;
const NAV_HEIGHT = 88;

export default {
  props: ["qrImg", "configs"],
  data() {
    return {
      logoImg,
      heroImg,
      highlightsImg,
      genresImg,
      immersiveImg,
      wishImg,
      creatorImg,
      downloadIcon,
      downloadLgIcon,
      playIcon,
      editIcon,
      menus: [
        { key: "home", label: "首页" },
        { key: "highlights", label: "内容亮点" },
        { key: "genres", label: "剧场类型" },
        { key: "wish", label: "心愿榜" },
        { key: "original", label: "原创内容" },
        { key: "about", label: "关于我们" }
      ],
      activeKey: "home",
      scale: 1,
      stageHeight: 0,
      locking: false,
      qrVisible: false,
      qrTitle: "手机扫码下载",
      scrollTimer: null
    };
  },
  computed: {
    scaleStyle() {
      return {
        width: PAGE_WIDTH + "px",
        transform: "scale(" + this.scale + ")",
        transformOrigin: "left top"
      };
    },
    navBarHeight() {
      return this.scale * NAV_HEIGHT + "px";
    }
  },
  mounted() {
    this.updateScale();
    window.addEventListener("resize", this.updateScale);
    document.addEventListener("keydown", this.onKeydown);
    this.$nextTick(() => {
      this.updateScale();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScale);
    document.removeEventListener("keydown", this.onKeydown);
    clearTimeout(this.scrollTimer);
    if (this.scrollRaf) {
      cancelAnimationFrame(this.scrollRaf);
    }
  },
  methods: {
    updateScale() {
      const scroller = this.$refs.scroller;
      const page = this.$refs.page;
      if (!scroller || !page) {
        return;
      }
      this.scale = scroller.clientWidth / PAGE_WIDTH;
      this.stageHeight = page.offsetHeight * this.scale;
    },
    onScroll() {
      if (this.locking) {
        return;
      }
      if (this.scrollRaf) {
        return;
      }
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = 0;
        this.syncActive();
      });
    },
    syncActive() {
      const scroller = this.$refs.scroller;
      const navBar = this.$refs.navBar;
      if (!scroller || !navBar) {
        return;
      }
      if (
        scroller.scrollTop + scroller.clientHeight >=
        scroller.scrollHeight - 4
      ) {
        this.activeKey = "about";
        return;
      }
      const line =
        scroller.getBoundingClientRect().top + navBar.offsetHeight + 1;
      let current = this.menus[0].key;
      this.menus.forEach(item => {
        const el = this.$refs[item.key];
        if (el && el.getBoundingClientRect().top <= line) {
          current = item.key;
        }
      });
      this.activeKey = current;
    },
    scrollToSection(key) {
      if (this.activeKey === key) {
        return;
      }
      const scroller = this.$refs.scroller;
      const section = this.$refs[key];
      const navBar = this.$refs.navBar;
      if (!scroller || !section || !navBar) {
        return;
      }
      this.activeKey = key;
      const top = Math.max(0, section.offsetTop * this.scale);
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches;
      this.locking = true;
      scroller.scrollTo({
        top,
        behavior: reduce ? "auto" : "smooth"
      });
      this.waitScrollEnd();
    },
    waitScrollEnd() {
      const scroller = this.$refs.scroller;
      clearTimeout(this.scrollTimer);
      const done = () => {
        scroller.removeEventListener("scroll", onScroll);
        this.locking = false;
        this.syncActive();
      };
      const onScroll = () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(done, 140);
      };
      scroller.addEventListener("scroll", onScroll);
      this.scrollTimer = setTimeout(done, 800);
    },
    openQr(title) {
      this.qrTitle = title;
      this.qrVisible = true;
    },
    closeQr() {
      this.qrVisible = false;
    },
    onKeydown(event) {
      if (event.key === "Escape") {
        this.closeQr();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pcm-scroll {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #0b0b0d;
  position: relative;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #f2f2f4;
  button {
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
    appearance: none;
  }
  button:focus {
    outline: none;
  }
  button:focus-visible {
    outline: 2px solid rgba(236, 35, 127, 0.85);
    outline-offset: 3px;
  }
}

.pcm-navBar {
  position: sticky;
  top: 0;
  z-index: 20;
  overflow: hidden;
  background: rgba(11, 11, 13, 0.98);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.pcm-navInner {
  position: relative;
  height: 88px;
}

.pcm-logo {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  .pcm-logoImg {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 23px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.23px;
    white-space: nowrap;
  }
}

.pcm-menu {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 48px;
}

.pcm-menuItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  transition: opacity 120ms ease;
  &:active {
    opacity: 0.72;
  }
}

.pcm-menuLabel {
  display: grid;
  font-size: 20px;
  line-height: 26px;
}

.pcm-menuGhost,
.pcm-menuText {
  grid-area: 1 / 1;
  white-space: nowrap;
}

.pcm-menuGhost {
  font-weight: 600;
  visibility: hidden;
}

.pcm-menuText {
  font-weight: 400;
  color: #f2f2f4;
  transition: color 200ms ease;
}

.pcm-menuItem.is-active .pcm-menuText {
  font-weight: 600;
  color: #ec237f;
}

.pcm-menuLine {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 5px;
  background: #ec237f;
  transform: scaleX(0.45);
  opacity: 0;
  transition: transform 220ms ease, opacity 220ms ease;
}

.pcm-menuItem.is-active .pcm-menuLine {
  transform: scaleX(1);
  opacity: 1;
}

.pcm-client {
  position: absolute;
  left: 1250px;
  top: 50%;
  border: 0;
  transform: translateY(-50%);
  width: 150px;
  height: 50px;
  border-radius: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  transition: transform 150ms ease, filter 150ms ease;
  span {
    font-size: 20px;
    font-weight: 600;
    line-height: 35px;
    color: #fff;
    white-space: nowrap;
  }
  &:active {
    transform: translateY(-50%) scale(0.97);
  }
}

.pcm-clientIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    height: 16px;
    display: block;
  }
}

.pcm-stage {
  position: relative;
}

.pcm-page {
  position: absolute;
  left: 0;
  top: 0;
}

.pcm-hero,
.pcm-highlights,
.pcm-genres,
.pcm-immersive,
.pcm-wish,
.pcm-creator {
  position: relative;
  width: 1440px;
  overflow: hidden;
}

.pcm-hero {
  height: 608px;
}
.pcm-highlights {
  height: 186px;
}
.pcm-genres,
.pcm-immersive {
  height: 864px;
}
.pcm-wish {
  height: 956px;
}
.pcm-creator {
  height: 768px;
}

.pcm-fill {
  width: 1440px;
  height: 100%;
  display: block;
  object-fit: cover;
}

.pcm-btn {
  position: absolute;
  z-index: 2;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: transform 150ms ease, filter 150ms ease;
  &:active {
    transform: scale(0.97);
  }
  span {
    font-weight: 600;
    color: #fff;
  }
}

.pcm-btnIcon {
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pcm-btnIconBrand {
  background: #ec237f;
}

.pcm-iconLg {
  width: 21px;
  height: 21px;
  display: block;
}

.pcm-iconPlay {
  width: 21px;
  height: 21px;
  display: block;
}

.pcm-iconEdit {
  width: 20px;
  height: 20px;
  display: block;
}

.pcm-btnDownload,
.pcm-btnExplore {
  top: 484px;
  width: 237px;
  height: 64px;
  border-radius: 32px;
  gap: 13px;
  span {
    font-size: 22px;
    line-height: 30px;
  }
  .pcm-btnIcon {
    width: 36px;
    height: 36px;
  }
}

.pcm-btnDownload {
  left: 743px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
}

.pcm-btnExplore {
  left: 1021px;
  background: #1b1b1f;
  border: 1.5px solid #ec237f;
  span {
    color: #f2f2f4;
  }
}

.pcm-btnWish {
  left: 567px;
  top: 782px;
  width: 306px;
  height: 68px;
  border-radius: 34px;
  gap: 12px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  span {
    font-size: 22px;
    line-height: 30px;
  }
  .pcm-btnIcon {
    width: 35px;
    height: 35px;
  }
}

.pcm-about {
  position: relative;
  width: 1440px;
  height: 346px;
  background: linear-gradient(90deg, #0b0b0d 0%, #1d0812 50%, #0b0b0d 100%);
}

.pcm-aboutInner {
  position: absolute;
  left: 393px;
  top: 117px;
  display: flex;
  align-items: center;
  gap: 64px;
}

.pcm-aboutLogo {
  display: flex;
  align-items: center;
  gap: 11px;
  img {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 42px;
    font-weight: 600;
    line-height: 51px;
    letter-spacing: -0.42px;
    white-space: nowrap;
  }
}

.pcm-aboutCopy {
  font-size: 34px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: 6px;
  white-space: nowrap;
  p {
    margin: 0;
  }
}

.pcm-footer {
  position: relative;
  width: 1440px;
  height: 265px;
  background: #141417;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
}

.pcm-brand {
  position: absolute;
  left: 40px;
  top: 37px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pcm-footerLogo {
  display: flex;
  align-items: center;
  gap: 4px;
  img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: block;
  }
  span {
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: -0.16px;
  }
}

.pcm-brandSlogan,
.pcm-addresses {
  margin: 0;
  color: #6b6b74;
  font-size: 12px;
  line-height: 17px;
  font-weight: 400;
}

.pcm-addresses {
  display: flex;
  flex-direction: column;
  gap: 8px;
  p {
    margin: 0;
    white-space: nowrap;
  }
  a {
    color: #ec237f;
    text-decoration: none;
    transition: opacity 150ms ease;
    &:hover {
      opacity: 0.8;
    }
  }
}

.pcm-footCol {
  position: absolute;
  top: 37px;
  display: flex;
  flex-direction: column;
  gap: 13px;
  font-size: 14px;
  line-height: 20px;
  color: #6b6b74;
  white-space: nowrap;
  p {
    margin: 0;
  }
}

.pcm-footTitle {
  color: #f2f2f4;
  font-weight: 600;
}

.pcm-footSupport {
  left: 770px;
}
.pcm-footAbout {
  left: 1010px;
}
.pcm-footLegal {
  left: 1250px;
}

.pcm-copyright {
  position: absolute;
  left: 1128px;
  top: 227px;
  margin: 0;
  color: #6b6b74;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
}

.pcm-qrMask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 11, 13, 0.72);
}

.pcm-qrCard {
  width: 320px;
  padding: 28px 24px 24px;
  box-sizing: border-box;
  border-radius: 16px;
  background: #1b1b1f;
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pcm-qrTitle {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #f2f2f4;
}

.pcm-qrBox {
  width: 180px;
  height: 180px;
  margin-top: 16px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b6b74;
  font-size: 14px;
}

.pcm-qrImg {
  width: 168px;
  height: 168px;
  display: block;
}

.pcm-qrSub {
  margin-top: 12px;
  color: #6b6b74;
  font-size: 13px;
  line-height: 18px;
}

.pcm-qrConfirm {
  width: 100%;
  height: 44px;
  border: 0;
  margin-top: 20px;
  border-radius: 22px;
  background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  transition: transform 150ms ease;
  &:active {
    transform: scale(0.97);
  }
}

.pcm-fade-enter-active,
.pcm-fade-leave-active {
  transition: opacity 200ms ease;
}
.pcm-fade-enter,
.pcm-fade-leave-to {
  opacity: 0;
}
</style>
